export default [
  {
    path: '/v2/stats/emp-income/detail',
    name: '员工收入明细表',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/v2/stats/emp-income/detail.vue`),
    meta: {
      permission: ['hr_wage_new_report_xzmx','hr_wage_new_report_ndpjgz']
    }
  },
  {
    path: '/v2/stats/emp-income/detail-ruichen',
    name: '集团员工收入明细表',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/v2/stats/emp-income/detail-ruichen.vue`),
    meta: {
      permission: ['hr_wage_new_report_xzmx_rc','hr_wage_new_report_ndpjgz']
    }
  },
  {
    path: '/v2/stats/emp-income/summary',
    name: '员工收入汇总表',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/v2/stats/emp-income/summary.vue`),
    meta: {
      permission: ['hr_wage_new_report_ndpjgz']
    }
  },
  {
    path: '/v2/stats/data-center',
    name: '数据中心',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/v2/stats/data-center/index.vue`),
    meta: {
      permission: ['hr_wage_new_report_data_center']
    }
  },
  {
    path: '/v2/stats/data-center-dashboard',
    name: '数据中心',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/v2/stats/data-center/dashboard.vue`),
    meta: {
      permission: ['hr_wage_new_report_data_center_zl']
    }
  },
  {
    path: '/v2/stats/data-center/custom-report-detail',
    name: '自定义报表详情',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/v2/stats/data-center/custom-report-detail.vue`),
    meta: {
      permission: ['hr_wage_new_report_zdybb_new','hr_wage_new_report_data_center']
    }
  },
  {
    path: '/v2/stats/emp-income/detailtabs',
    name: '收入明细分计税类型表',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/v2/stats/emp-income/salary-detail-tabs.vue`),
    meta:{
      permission: ['hr_wage_new_report_per_taxtype_xzmx']
    }
  },
]
